import { render, staticRenderFns } from "./MemberDocuments.vue?vue&type=template&id=3392ccac"
import script from "./MemberDocuments.vue?vue&type=script&lang=js"
export * from "./MemberDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports